<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Регистрация</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<section class="my-account py-40">
			<div class="container-fluid">
				<div class="row row-gap-4">
					<div class="col-xl-6 offset-xl-3">
						<div class="account">
							<form @submit.prevent="onRegisterSubmit" class="contact-form">
								<div class="row">
									<div class="col-md-6">
										<div class="input-block mb-16">
											<input type="text" name="lastname" id="lastName" class="form-control" placeholder="Фамилия" v-model="lastname" required>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M10 0C7.09223 0 4.72656 2.36566 4.72656 5.27344C4.72656 8.18121 7.09223 10.5469 10 10.5469C12.9078 10.5469 15.2734 8.18121 15.2734 5.27344C15.2734 2.36566 12.9078 0 10 0ZM10 9.375C7.7384 9.375 5.89844 7.53504 5.89844 5.27344C5.89844 3.01184 7.7384 1.17188 10 1.17188C12.2616 1.17188 14.1016 3.01184 14.1016 5.27344C14.1016 7.53504 12.2616 9.375 10 9.375Z"
													fill="#141516" />
												<path
													d="M16.5612 13.992C15.1174 12.5261 13.2035 11.7188 11.1719 11.7188H8.82812C6.79656 11.7188 4.88258 12.5261 3.43883 13.992C2.00215 15.4507 1.21094 17.3763 1.21094 19.4141C1.21094 19.7377 1.47328 20 1.79688 20H18.2031C18.5267 20 18.7891 19.7377 18.7891 19.4141C18.7891 17.3763 17.9979 15.4507 16.5612 13.992ZM2.40859 18.8281C2.70215 15.5045 5.46918 12.8906 8.82812 12.8906H11.1719C14.5308 12.8906 17.2979 15.5045 17.5914 18.8281H2.40859Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<input type="text" name="name" id="firstName" class="form-control" placeholder="Имя" v-model="firstname" required>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M10 0C7.09223 0 4.72656 2.36566 4.72656 5.27344C4.72656 8.18121 7.09223 10.5469 10 10.5469C12.9078 10.5469 15.2734 8.18121 15.2734 5.27344C15.2734 2.36566 12.9078 0 10 0ZM10 9.375C7.7384 9.375 5.89844 7.53504 5.89844 5.27344C5.89844 3.01184 7.7384 1.17188 10 1.17188C12.2616 1.17188 14.1016 3.01184 14.1016 5.27344C14.1016 7.53504 12.2616 9.375 10 9.375Z"
													fill="#141516" />
												<path
													d="M16.5612 13.992C15.1174 12.5261 13.2035 11.7188 11.1719 11.7188H8.82812C6.79656 11.7188 4.88258 12.5261 3.43883 13.992C2.00215 15.4507 1.21094 17.3763 1.21094 19.4141C1.21094 19.7377 1.47328 20 1.79688 20H18.2031C18.5267 20 18.7891 19.7377 18.7891 19.4141C18.7891 17.3763 17.9979 15.4507 16.5612 13.992ZM2.40859 18.8281C2.70215 15.5045 5.46918 12.8906 8.82812 12.8906H11.1719C14.5308 12.8906 17.2979 15.5045 17.5914 18.8281H2.40859Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="email" name="mail" autocomplete="off" class="form-control" placeholder="Ваш Email" v-model="email" required>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M18.2422 2.96875H1.75781C0.786602 2.96875 0 3.76023 0 4.72656V15.2734C0 16.2455 0.792383 17.0312 1.75781 17.0312H18.2422C19.2053 17.0312 20 16.2488 20 15.2734V4.72656C20 3.76195 19.2165 2.96875 18.2422 2.96875ZM17.996 4.14062C17.6369 4.49785 11.4564 10.6458 11.243 10.8581C10.9109 11.1901 10.4695 11.3729 10 11.3729C9.53047 11.3729 9.08906 11.1901 8.75594 10.857C8.61242 10.7142 2.50012 4.63414 2.00398 4.14062H17.996ZM1.17188 15.0349V4.96582L6.23586 10.0031L1.17188 15.0349ZM2.00473 15.8594L7.06672 10.8296L7.9284 11.6867C8.48176 12.2401 9.21746 12.5448 10 12.5448C10.7825 12.5448 11.5182 12.2401 12.0705 11.6878L12.9333 10.8296L17.9953 15.8594H2.00473ZM18.8281 15.0349L13.7641 10.0031L18.8281 4.96582V15.0349Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="password" name="password" autocomplete="off" class="form-control" placeholder="Пароль" v-model="password" required>
											<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z" /></svg>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="password" name="password2" autocomplete="off" class="form-control" placeholder="Повтор пароля" v-model="password2" required>
											<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z" /></svg>
										</div>
									</div>
									<div class="col-md-6">
										<button type="submit" class="cus-btn-3" :disabled="btnRegisterDisabled">Создать аккаунт</button>
									</div>
									<div class="col-md-6 text-end">
										<router-link :to="{path: '/login'}" class="cus-btn-2">Войти</router-link>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
								{{error}}
								<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		firstname: '',
		lastname: '',
		email: '',
		password: '',
		password2: '',
		
		btnRegisterDisabled: false,
		error: '',
	}),
	methods: {
		async onRegisterSubmit(){
			this.error = '';
			this.btnRegisterDisabled = true;
			
			const params = {
				firstname: this.firstname,
				lastname: this.lastname,
				email: this.email,
				password: this.password,
				password2: this.password2,
			};
			const res = await this.authModel.doRegister(params);
			
			this.btnRegisterDisabled = false;
			if(res.success){
				this.$router.push('/login');
			} else {
				this.error = res.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits
	},
};
</script>